// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): РЕЕСТР ОБЪЯСНЕНИЙ — сливает карты областей в одну карту «ключ → запись».
// Ключ — '<область>.<элемент>[.<вариант>]' (menuPanel.fav.page); область держит свой префикс, поэтому карты не пересекаются. Запись — функция
// (vars, ctx) → { title, what, why, click, now, affects, stored, setting, hotkey, states } (формат и правила — utils/uiHelp.js и
// handoff-files/ui-help-2026-09-24/README.md). Новая область: файл './<область>.js' с export default { '<область>.<элемент>': (vars, ctx) => ({…}) },
// строка импорта ниже и имя в UI_HELP_AREAS; переводы — src/i18n/messages/uk.json / ru.json. Дубль ключа — предупреждение в консоли, побеждает первая карта.
import menuPanel from './menuPanel.js'
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: области «шапка и навигация» (рейл страниц, список столов) и «грид» (ссылочная ячейка) —
// пока элементы со своей подсказкой и кнопками-действиями (строки дописываются в их подсказку); волны U2 / U5 дописывают остальные ключи в те же файлы
import topbarNav from './topbarNav.js'
import grid from './grid.js'
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U4: область «chips» (панель чипсов шапки стола и таблиц, spec-chips.json, 147 ключей / 99 якорей в AttrChips.vue)
import chips from './chips.js'
// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U6: область «графики и карты» (203 ключа chart.*, spec-charts-maps.json)
import charts from './charts.js'

// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3: область «widget» (шапка виджета, spec-widget.json, 106 ключей)
import widget from './widget.js'
// IE 2026 10 09 / ODOO-345618 (заказ Игоря: согласование на сегменте): область «approval» — подменю «Approval» командной панели и его команды, пилюля статуса в заголовке строки-группы, раздел APPROVAL формы ячейки
import approval from './approval.js'
// IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE9: объяснения по Alt обзора согласования (ApprovalOverview.vue), ключи approval.ov.*
import approvalOverview from './approvalOverview.js'
// IE 2026 10 28 / ODOO-5800 (заказ Игоря: вкладка History of changes в отчёте, вариант A): область «pmHistory» — вкладка «History of changes» отчёта (AttrPmHistory.vue)
import pmHistory from './pmHistory.js'
// IE 2026 10 29 / ODOO-5800 (заказ Игоря: история изменений списка, ie-dm7 #114916): область «listHistory» — вкладка «History of changes» списка (AttrListHistory.vue + listHistory/Lh*.vue)
import listHistory from './listHistory.js'
export const UI_HELP_AREAS = { menuPanel, topbarNav, grid, chips, charts, widget, approval, approvalOverview, listHistory, pmHistory }   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U4: область «chips» · U6: область «charts»   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3: область «widget»   // IE 2026 10 28 / ODOO-5800 (заказ Игоря: вкладка History of changes в отчёте, вариант A): + pmHistory   // IE 2026 10 29 / ODOO-5800 (заказ Игоря: история изменений списка, ie-dm7 #114916): + listHistory

export const UI_HELP = {}
for (const [area, map] of Object.entries(UI_HELP_AREAS)) {
    for (const [key, fn] of Object.entries(map || {})) {
        if (typeof fn !== 'function') continue
        if (key in UI_HELP) { try { console.warn(`uiHelp: duplicate key ${key} (area ${area}) — the first one wins`) } catch (e) { /* без консоли */ } continue }
        UI_HELP[key] = fn
    }
}

// регистрация карты во время работы (область, подключаемая лениво / из другого модуля): существующие ключи не перетираются, возвращает число добавленных
export function uiHelp_register(map, area = '') {
    let n = 0
    for (const [key, fn] of Object.entries(map || {})) {
        if (typeof fn !== 'function' || key in UI_HELP) continue
        UI_HELP[key] = fn
        n++
    }
    if (area && !UI_HELP_AREAS[area]) UI_HELP_AREAS[area] = map
    return n
}

export function uiHelp_keys() { return Object.keys(UI_HELP) }

export default UI_HELP
